export class AcceptedTermsOfUse
{
    principalId:number;
    userId:string;
    version:number;
}


// WEBPACK FOOTER //
// ./src/app/modules/terms-of-use/entity/accepted-terms-of-use.ts